var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h3',{staticClass:"display-2 text-center"},[_vm._v("Development areas")]),_c('div',{staticClass:"d-flex"},[_c('v-btn',{staticClass:"link",attrs:{"color":"primary","rounded":"","to":{ name: 'test-form' }}},[_vm._v("Test Image Upload")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }